import { Button, ControlLabel, Form, FormControl, FormGroup, Modal } from 'rsuite';

import { LoadingSpinerArea } from '../../../../../../components/LoadingSpinner';
import { TABLE_TRACKER_AREA } from '../../constants';
import styles from './ModalSaveFilters.module.scss';

export type ModalSaveFiltersProps = {
  show?: boolean;
  filterName?: string;
  onHide: () => void;
  onChangeFilterName: (value: string) => void;
  onConfirm: () => void;
};

export const ModalSaveFilters = ({ show, filterName, onHide, onChangeFilterName, onConfirm }: ModalSaveFiltersProps) => (
  <Modal className={styles.modalSaveFilters} show={show} onHide={onHide}>
    <Modal.Header>
      <Modal.Title>Salvar filtro</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Form fluid>
        <FormGroup>
          <ControlLabel>Nome do filtro</ControlLabel>
          <FormControl name="nome" value={filterName} onChange={onChangeFilterName} />
        </FormGroup>
      </Form>
    </Modal.Body>
    <Modal.Footer>
      <Button appearance="primary" onClick={onConfirm}>
        Salvar filtro
      </Button>
      <Button onClick={onHide} appearance="default">
        Descartar
      </Button>
    </Modal.Footer>
    <LoadingSpinerArea size="sm" area={TABLE_TRACKER_AREA} />
  </Modal>
);
